/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesList } from "../../funcs/workspacesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WorkspacesRequest$inboundSchema,
};

export const tool$workspacesList: ToolDefinition<typeof args> = {
  name: "workspaces_list",
  description: `List workspaces

Retrieves a list of workspaces for a given account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
